import { gsap } from 'gsap';

import { gsapTimelineFunc } from '../gsap-config';

export const bounceIn: gsapTimelineFunc = (targets) => {
  return gsap
    .timeline()
    .fromTo(
      targets,
      { duration: 0, scale: 0.0, opacity: 0, transformOrigin: 'center center' },
      { duration: 0.2, scale: 1.3, opacity: 1 }
    )
    .to(targets, { duration: 0.2, scale: 0.8 })
    .to(targets, { duration: 0.2, scale: 1.1 })
    .to(targets, { duration: 0.2, scale: 0.9 })
    .to(targets, { duration: 0.2, scale: 1 });
};
